import React from "react";
import NavigationTextWithIcon from "@src/components/atoms/buttons/navigition-text-with-icon/navigation-text-with-icon";

// Firmware icons (active & inactive states)
import firmwareActive from "@src/assets/svg/firmware-icon-active.svg";
import firmwareInactive from "@src/assets/svg/firmware-icon-inactive.svg";

// Configuration icons (active & inactive states)
import configurationsActive from "@src/assets/svg/configurations-icon-active.svg";
import configurationsInactive from "@src/assets/svg/configurations-icon-inactive.svg";

// Settings icons (active & inactive states)
import settingActive from "@src/assets/svg/settings-icon-active.svg";
import settingInactive from "@src/assets/svg/settings-icon-inactive.svg";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@src/reducers/store";
import {
  OTAActiveViewType,
  updateOTAActiveView,
} from "@src/reducers/your-reducer";

import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { useI18N } from "@src/language/language-context";

// Type definition for OTA navbar item configuration
interface NavBarItemProp {
  key: OTAActiveViewType;
  label: string;
  inActiveIcon: string;
  activeIcon: string;
}

const OTANavbar = () => {
  // Select currently active OTA view from Redux store with fallback
  const otaActiveView: OTAActiveViewType =
    useSelector((state: RootState) => state.yourSlice?.otaActiveView) ??
    "firmware";

  // Typed Redux dispatch for OTA view updates
  const dispatch = useDispatch<AppDispatch>();

  // Hook for internationalized text labels
  const i18n = useI18N();

  // Translated navbar labels
  const texts = {
    firmwareText: i18n("modules.otaNavbar.firmwareText"),
    configurationsText: i18n("modules.otaNavbar.configurationsText"),
    settingsText: i18n("modules.otaNavbar.settingsText"),
  };

  // Dispatch selected OTA view to Redux
  const selectNavItem = (key: OTAActiveViewType) => {
    dispatch(updateOTAActiveView(key));
  };

  // Configuration array for rendering OTA navigation items
  const NAVBAR_ITEMS: NavBarItemProp[] = [
    {
      key: "firmware",
      label: texts.firmwareText,
      inActiveIcon: firmwareInactive,
      activeIcon: firmwareActive,
    },
    {
      key: "configurations",
      label: texts.configurationsText,
      inActiveIcon: configurationsInactive,
      activeIcon: configurationsActive,
    },
    // {
    //   key: "settings",
    //   label: texts.settingsText,
    //   inActiveIcon: settingInactive,
    //   activeIcon: settingActive,
    // },
  ];

  return (
    // Vertical container wrapping OTA navigation items
    <FlexColumnContainer>
      {NAVBAR_ITEMS.map((item) => {
        return (
          <NavigationTextWithIcon
            key={item.key}
            label={item.label}
            isActive={otaActiveView === item.key}
            activeIcon={item.activeIcon}
            inActiveIcon={item.inActiveIcon}
            onClick={() => selectNavItem(item.key)}
          />
        );
      })}
    </FlexColumnContainer>
  );
};

export default OTANavbar;
